<template>
  <div id="app">
    <cookie-consent />
    <router-view/>

    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" /> -->
  </div>
</template>

<script>
import Head from './components/layout/head.vue'
import Bottom from './components/layout/bottom.vue'
import store from './store/index'
// 引入 cookieConsent 组件
import cookieConsent from '@/components/cookieConsent';
export default {
  components: {
    Head,
    Bottom,
    cookieConsent
  },
  data() {
    return {}
  },
  watch: {
    offsetWidth(val, oldVal) {
      if (val !== oldVal) {
        location.reload()
      }
    }
  },
  methods: {
    setClient() {
      const screenWidth = document.body.offsetWidth
      if (screenWidth < 980) {
        store.dispatch('toggleScreen', false)
      } else {
        store.dispatch('toggleScreen', true)
      }
    }
  },
  mounted() {
    this.setClient()
  }
}
// This starter template is using Vue 3 experimental <script setup> SFCs
// Check out https://github.com/vuejs/rfcs/blob/master/active-rfcs/0040-script-setup.md
</script>
<style lang="less">
#app {
  width: 100%;
  font-family: PingFang SC;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}
html, body {
  min-height: 100%;
  font-size: 16px;
  margin: 0;
  padding: 0;
  // background-color: #F6F6F6;
  background: #F6F6F6;
  font-family: PingFang SC;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
p, ul {
  margin: 0;
  padding: 0;
}
</style>
